import WordstoDescribe from "../images/publications/words-to-describe-what-im-feeling.png";
import PeerSupportMisalignments from "../images/publications/is-this-really.png";
import LLMDisinformation from "../images/publications/sword-and-shield.png";
import Placeholder from "../images/placeholder.png";
import ImNotAbleToBeThereForYou from "../images/publications/im-not-able-to-be-there-for-you.png";
import ActsOfConfiguration from "../images/publications/acts-of-configuration.png";
import RedistributingVoiceAndResponsibility from "../images/publications/redistributing-voice-responsibility.png";
import PeerSupportSingapore from "../images/publications/i-said-things-peer-support-singapore.png";
import EnvisioningEcosystem from "../images/publications/envisioning-ecosystem.jpg";
import TowardsUnderstandingEmotions from "../images/publications/towards-understanding-emotions.png";
import CADiabetes from "../images/publications/ca-diabetes.jpg";
import SocialBehaviourUnderstanding from "../images/publications/social-behaviour-understanding.png";

export const ADMIN_IMAGES = {
  WordstoDescribe,
  PeerSupportMisalignments,
  LLMDisinformation,
  Placeholder,
  ImNotAbleToBeThereForYou,
  ActsOfConfiguration,
  RedistributingVoiceAndResponsibility,
  PeerSupportSingapore,
  EnvisioningEcosystem,
  TowardsUnderstandingEmotions,
  CADiabetes,
  SocialBehaviourUnderstanding,
};

export const ADMIN_IMAGE_KEYS = Object.keys(ADMIN_IMAGES);

export const ADMIN_FILES = [
  "files/2026-dbcs-seed-award-evidence-pack.pdf",
  "files/2026-words-to-describe-what-im-feeling.pdf",
  "files/2026-acts-of-configuration.pdf",
  "files/2026-im-not-able-to-be-there-for-you.pdf",
  "files/2025-is-this-really-misalignments-peer-support.pdf",
  "files/2025-sword-and-shield.pdf",
  "files/2025-i-said-things-peer-support-singapore.pdf",
  "files/2025-envisioning-an-ai-enhanced-mental-health-ecosystem.pdf",
  "files/2025-envisioning-an-ai-enhanced-mental-health-ecosystem-poster.pdf",
  "files/2025-communication-games-to-study-emerging-disinformation-scenarios-with-llms.pdf",
  "files/2025-communication-games-to-study-emerging-disinformation-scenarios-with-llms-poster.pdf",
  "files/2024-towards-understanding-emotions.pdf",
  "files/2024-towards-understanding-emotions-poster.pdf",
  "files/2021-designing-ai-based-conversational-agent.pdf",
  "files/2020-social-behaviour-understanding.pdf",
  "files/glowingguide_cn.pdf",
  "files/glowingguide_eng.pdf",
  "files/kelliepandasg_cn.pdf",
  "files/kelliepandasg_eng.pdf",
];

export const fileBasename = (path = "") => path.split("/").pop() || path;
